import http from '../http-common';

export const signupAcademy = (payload) => http.post('/academy/signup', payload).then(r => r.data);
